import { ButtonPrimary, SuccessFeedbackScreen, skinVars, useWindowSize } from '@telefonica/mistica';
import { useTranslation } from 'react-i18next';
import React, { useEffect } from 'react';
import './index.scss';
import { useNavigate } from 'react-router-dom';
import navigateParams from '../../../../../utils/navigation/navigateParams';
import { TrackingEvents } from '../../../../../utils/dataTransformation/tracking';
import { isWebviewAndroid, isWebviewIOS } from '../../../../../utils/navigation/controlDevices';

const RehabilitationLinesFeedback: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { trackingScreenView } = new TrackingEvents();
    const size = useWindowSize();

    const sendToNative = (url: string, title: string) => {
        const type = 'modeFlow-backgroundBlue';
        const queryParams = {};
        if (navigateParams(type, url, queryParams, title)) {
            navigate(url);
        }
    };

    useEffect(() => {
        if (!(isWebviewAndroid || isWebviewIOS)) {
            trackingScreenView();
        }
    }, []);

    return (
        <div
            className='rehabilitationLinesFeedback-page'
            style={{ background: size.width < 1024 || size.height < 550 ? skinVars.colors.backgroundBrand : '' }}
        >
            <SuccessFeedbackScreen
                title={t('rehabilitationLinesInfoFeedbackTitle')}
                description={t('rehabilitationLinesInfoFeedbackDescription')}
                primaryButton={
                    <ButtonPrimary
                        onPress={() => {
                            sendToNative('/bills', 'Facturas');
                        }}
                    >
                        {t('buttonUnderstoodFeedback')}
                    </ButtonPrimary>
                }
            ></SuccessFeedbackScreen>
        </div>
    );
};

export default RehabilitationLinesFeedback;
